import React, { useState } from 'react';

const InfoIcon = (props) => {
	const [isShown, setIsShown] = useState(false);

	return (
		<div className="i-icon-container">
			<i
				alt="i"
				className="fas fa-info-circle"
				onMouseEnter={() => setIsShown(true)}
				onMouseLeave={() => setIsShown(false)}
			></i>
			<div
				className={
					'hover-text' +
					(props.left ? ' left' : '') +
					(isShown ? ' active' : '')
				}
				dangerouslySetInnerHTML={{ __html: props.text }}
			/>
		</div>
	);
};

export default InfoIcon;
